export function getLivingConditions(params: { [key: string]: boolean | null }) {
  let temp = Object.keys(params)
    .map(key => {
      if (params[key]) {
        return `livingConditions=${key}`;
      }

      return null;
    })
    .filter(Boolean);

  if (temp.length > 1) {
    temp = temp.map((item: string, index: number) => {
      const [key, value] = item.split('=');

      return `${key}[${index}]=${value}`;
    });
  }

  return temp.join('&');
}
